import { CanActivateFn, Router } from '@angular/router';
import { GeneralService } from '../services/general.service';
import { inject } from '@angular/core';


export const altomateonlyGuard: CanActivateFn = (route, state) => {

  // Simulating an asynchronous check (e.g., an API call to validate the token)
  return new Promise<boolean>(async (resolve) => {
    const generalService = inject(GeneralService);
    const router = inject(Router);

    if(generalService.isNativePlatform() || generalService.isAltomateLink()) {
      console.log('found')
      resolve(true);
    } else {
      // If not on Altomate platform, redirect to login page
      console.log('no found')
      router.navigate(['/not-found']);
      resolve(false);
    }
  });

};